import { render, staticRenderFns } from "./TeachingImage.vue?vue&type=template&id=2aae21b0&scoped=true&"
import script from "./TeachingImage.vue?vue&type=script&lang=js&"
export * from "./TeachingImage.vue?vue&type=script&lang=js&"
import style0 from "./TeachingImage.vue?vue&type=style&index=0&id=2aae21b0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aae21b0",
  null
  
)

export default component.exports